import MapPin from './MapPin'
import enhance from './MapPin.enhancer'

export default enhance(MapPin)



// WEBPACK FOOTER //
// ./src/components/MapPin/index.js